<template>
  <div>
    <div class="empty">
      <img src="../assets/img/sorry.png" alt="">
      <div class="title">
        <h3>抱歉，没有检索到您需要的记录，建议尝试：</h3>
        <p>- 检查输入检索词是否有误</p>
        <p>- 调整检索范围条件</p>
        <p>- 选择其它检索词</p>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    
  }
</script>

<style scoped lang="scss">
.empty{
  width: 100%;
    text-align: center;
    margin: 100px auto;
    .title{
      display: inline-block;
      margin-left: 20px;
      p{
        color: #7d8a94;

    text-align: left;
    font-weight: 500;
    font-size: 14px;
      }
    }
}

</style>